import mutations from './mutations'

const store = {
  state() {
    return {
      selectedFile: null,
      currentFolder: 'OTHER',
      documentDragCounter: 0,
      fileDragCounter: 0,
    }
  },
  mutations,
}

export default store

export * from './mutationTypes'
